import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var BrandStory = function(param) {
    var name = param.name, hasPromoText = param.hasPromoText, showCategoryBrandStory = param.showCategoryBrandStory, description = param.description;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            showCategoryBrandStory && !!name ? /*#__PURE__*/ _jsxs(Column, {
                align: "flex-start",
                flex: 1,
                style: {
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ _jsx(HorizontalLine, {}),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(BrandStoryWrapper, {
                        $lines: hasPromoText ? 2 : 3,
                        children: description
                    })
                ]
            }) : null
        ]
    });
};
var BrandStoryWrapper = styled(Typography).attrs({
    forwardedAs: "p",
    color: Core.text.subdued,
    letterSpacing: 0.25
}).withConfig({
    componentId: "sc-1c710093-0"
})([
    "&&&{position:relative;width:100%;display:-webkit-box;overflow:hidden;max-height:",
    ";margin-bottom:7.5%;-webkit-line-clamp:",
    ";text-overflow:ellipsis;-webkit-box-orient:vertical;}"
], function(props) {
    return "calc(22px * ".concat(props.$lines, ")");
}, function(props) {
    return props.$lines;
});
